var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreyHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_189_4521)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 16L11.41 14.849C6.94667 10.7771 4 8.08283 4 4.79564C4 2.10136 6.09733 0 8.76667 0C10.2747 0 11.722 0.706267 12.6667 1.81362C13.6113 0.706267 15.0587 0 16.5667 0C19.236 0 21.3333 2.10136 21.3333 4.79564C21.3333 8.08283 18.3867 10.7771 13.9233 14.849L12.6667 16Z",
    fill: "#3C3C3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5789 14.6647L11.5785 14.6644C9.34193 12.6239 7.5055 10.9462 6.22528 9.37043C4.94786 7.79809 4.25 6.35754 4.25 4.79564C4.25 2.2383 6.23653 0.25 8.76667 0.25C10.1985 0.25 11.5774 0.92191 12.4765 1.97588L12.6667 2.19883L12.8569 1.97588C13.756 0.92191 15.1348 0.25 16.5667 0.25C19.0968 0.25 21.0833 2.2383 21.0833 4.79564C21.0833 6.35754 20.3855 7.79809 19.108 9.37043C17.8278 10.9462 15.9914 12.6239 13.7548 14.6644L13.7545 14.6647L12.6667 15.661L11.5789 14.6647Z",
    stroke: "white",
    strokeWidth: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_189_4521",
    x: 0,
    y: 0,
    width: 25.3333,
    height: 24,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_189_4521"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_189_4521",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyHeart);
export default __webpack_public_path__ + "static/media/grey-heart.8f99ba5f38f5aca866b1c036580dcbb2.svg";
export { ForwardRef as ReactComponent };